import React from 'react';

const Block = ({ className }) => <div className={`animate-pulse rounded-xl bg-slate-200/70 ${className}`} />;

export const DashboardSkeleton = () => (
  <div className="space-y-4" data-testid="dashboard-skeleton">
    <Block className="h-20" />
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <Block className="h-28" />
      <Block className="h-28" />
      <Block className="h-28" />
      <Block className="h-28" />
    </div>
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
      <Block className="h-64 lg:col-span-2" />
      <Block className="h-64" />
    </div>
  </div>
);

export default DashboardSkeleton;
